/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
import repository from '@bingads-webui-static-legacy/bulk-edit/bulkEdit/bulkEditRepository';
import Poller from '@bingads-webui-static-legacy/bulk-edit/bulkEdit/jobStatePoller';
import JobModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';
import bulkEditStatus from '@bingads-webui-static-legacy/schema/bulkEdit/status';
import cacheManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
var getPendingJobs = function (jobs) {
  return _.filter(jobs, function (item) {
    var status = item.get('Status');
    return status === bulkEditStatus.inProgress || status === bulkEditStatus.pendingStart || status === 'PendingFileUpload';
  });
};
var successHandler = function (pendingJobModels) {
  var jobs = _.filter(pendingJobModels.models, function (item) {
    var status = item.get('Status');
    return status === bulkEditStatus.completed || status === bulkEditStatus.completedWithErrors || status === bulkEditStatus.failed;
  });
  if (jobs && jobs.length > 0) {
    cacheManager.updateContext(['KeywordGrid']);
  }
};
export default {
  init: function () {
    repository.getHistory(0, 20).then(function (response) {
      if (response && response.items && response.items.length > 0) {
        var poller = new Poller({
          success: successHandler,
          schedule: 7000
        });
        var jobModels = _.map(response.items, function (item) {
          return new JobModel(item);
        });
        var pendingJobModels = getPendingJobs(jobModels);
        pendingJobModels.length > 0 && poller.start(pendingJobModels);
      }
    });
  }
};

